import { useMemo } from 'react';

/**
 * Derives `loading` for `Table` when rows are filled asynchronously from `data.items`
 * (e.g. useEffect / useLayoutEffect after usePaginatedRequest). Avoids showing an empty
 * state or stale rows for a frame between the request finishing and row state updating.
 */
export function usePaginatedTableLoading(
  isLoading: boolean,
  dataItems: Array<{ id?: unknown }> | undefined,
  rows: Array<{ id?: unknown }>,
): boolean {
  const itemsCount = dataItems?.length ?? 0;

  const rowsSyncedWithItems = useMemo(() => {
    const items = dataItems;
    if (!items?.length) {
      return rows.length === 0;
    }
    if (rows.length !== items.length) {
      return false;
    }
    return items.every((item, index) => rows[index]?.id === item.id);
  }, [dataItems, rows]);

  return isLoading || (itemsCount > 0 && !isLoading && !rowsSyncedWithItems);
}
